<template>
  <div id="invoice-issues">
    <div class="flex justify-space-between align-center">
      <h2 class="title">Factura Creada</h2>
      <router-link to="/invoiceable-sales" class="link">
        &lt; Regresar
      </router-link>
    </div>
    <div class="card">
      <div class="concept">
        <h4>Conceptos</h4>
        <p
          v-for="(concept, index) in createdInvoice.concepts"
          :key="index"
        >
          {{ concept.description }}
        </p>
      </div>
      <div class="concept">
        <h4>Cantidad</h4>
        <p>${{ createdInvoice.total }}</p>
      </div>
      <div class="concept">
        <h4>Fecha</h4>
        <p>{{ createdInvoice.created_at }}</p>
      </div>
      <div class="concept">
        <h4>Datos de facturación</h4>
        <p>{{ createdInvoice.legal_name }}</p>
        <p>{{ createdInvoice.email }}</p>
        <p>{{ createdInvoice.rfc }}</p>
      </div>
      <div class="concept">
        <h4>Tipo de pago</h4>
        <p>{{ createdInvoice.payment_type }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CreatedInvoice',
  computed: {
    ...mapState('invoices', ['createdInvoice'])
  },
  mounted () {
    if (!Object.keys(this.createdInvoice).length) {
      this.$router.push('/invoiceable-sales')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#invoice-issues {
  text-align: start;
  margin: 1rem 2rem;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  padding: 1rem 2rem;
  border-radius: 25px;
  background-color: $white;
}

.concept {
  margin: 2.5rem 0;
}

.card-information {
  margin-left: 2rem;
}

.icon {
  margin: 0 .5rem 0 -1.5rem;
}

.btn {
  color: $white;
  background-color: $light-blue;
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

h4 {
  margin: 1rem 0 .25rem 0;
}

p {
  margin: .5rem 1.5rem;
}

@media screen and (max-width: 60rem) {
  .card {
    text-align: center;
  }

  .link {
    display: none;
  }

  .concept {
    text-align: left;
    margin: 1.5rem 0;
  }

  .card-information {
    white-space: nowrap;
    margin-left: 0;
  }

  .icon {
    margin: 0;
  }

  p {
    margin: .5rem 0;
  }
}
</style>
